import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardsGrid from '../CardsGrid/CardsGrid';
import styles from './SectionCardsGrid.module.css';

export const COUNT_SKELETON_CARDS = 8;

const SectionCardsGrid = ({
  items,
  render,
  itemClassName,
  dataLayerEventData,
  eventItemFieldName,
  className,
  ...props
}) => (
  <CardsGrid
    items={items}
    className={classNames(styles.component, styles.section, className)}
    itemClassName={classNames(styles.item, itemClassName)}
    render={render}
    {...props}
  />
);

SectionCardsGrid.propTypes = {
  items: PropTypes.array,
  render: PropTypes.func,
  itemClassName: PropTypes.string,
  dataLayerEventData: PropTypes.shape({}),
  eventItemFieldName: PropTypes.string,
};

SectionCardsGrid.defaultProps = {
  items: [],
  render: () => null,
  itemClassName: '',
};

export default SectionCardsGrid;
